import './dashboard.scss';
import React, { useEffect, useState } from 'react';
import { useStores } from 'src/components/store';
import { observer } from 'mobx-react-lite';
import Loader from 'src/components/shared/loader/loader';
import { MainPages } from 'src/utils/enums';
import { BlockedEvents } from './blocked-events/blocked-event';
import { CurrentPolicy } from './current-policy/current-policy';
import { NetworkActivity } from './network-activity/network-activity';
import DateRangePicker from '../../shared/date-range-picker/date-range-picker';
import { DateRangeObject, handleDateRange } from '@src/utils/datesUtils';
import { VersionButtonContainer } from '../version-button/version-button-container';
import { OnboardingModals } from '../onboarding-modals/onboarding-modals';
import { usePageViewEvent } from '../../shared/hooks/use-page-view-event';

export const Dashboard: React.FC = observer(() => {
    const { fwVersionStore, dashboardStore, customerStore, uiStore, userStore } = useStores();
    const [isDashboardLoading, setIsDashboardLoading] = useState(!fwVersionStore.fwVersions);
    const [range, setRange] = useState<any>(null);

    usePageViewEvent(MainPages.OVERVIEW);

    useEffect(() => {
        uiStore.setMainPage(MainPages.OVERVIEW);
    }, []);

    useEffect(() => {
        dashboardStore.initializeRange();
        const { fromDate, toDate } = handleDateRange(dashboardStore.dateRange);
        setRange({ from: fromDate, to: toDate });
    }, [customerStore.serviceId]);

    useEffect(() => {
        setIsDashboardLoading(!fwVersionStore.fwVersions);
    }, [fwVersionStore.fwVersions]);

    const onDateRangeChange = (selectedOption: string, rangeObj: DateRangeObject | undefined) => {
        const { fromDate, toDate } = handleDateRange(rangeObj ?? selectedOption);
        setRange({ from: fromDate, to: toDate });
        dashboardStore.setDateRange(rangeObj ?? selectedOption);
    };

    return <div className="dashboard-page">
        {(fwVersionStore.isLoading || isDashboardLoading) && <Loader type="full-screen"/>}

        {!isDashboardLoading && fwVersionStore.fwVersions && !userStore.isReadOnlyUser &&
            customerStore.isSingleConnection && <OnboardingModals />}

        <div className="dashboard-header">
            <div className="dashboard-title">Overview</div>
            <DateRangePicker defaultValue={dashboardStore.dateRange} onDateRangeChange={onDateRangeChange}/>
            <VersionButtonContainer isShowPartialLabels/>
        </div>

        {range &&
            <div className="dashboard-page-wrapper">
                <div className="dashboard-page-content">
                    <NetworkActivity from={range.from} to={range.to} />
                    <div className="dashboard-content-bottom">
                        <BlockedEvents from={range.from} to={range.to} />
                        <CurrentPolicy />
                    </div>
                </div>
            </div>}
    </div>;
});